import { faCaretDown } from "@fortawesome/free-solid-svg-icons/faCaretDown";
import { faCaretUp } from "@fortawesome/free-solid-svg-icons/faCaretUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classnames from "classnames";
import React, { useContext, useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { AD_MANAGER_SUBROUTES } from "../../constants/subroutes";
import styles from "../../styles/ProfileSideNav.module.scss";
import { RouteContext } from "../UserAccount";

export default function ProfileSideNav(props) {
  const location = useLocation();
  const { setSubTab } = useContext(RouteContext);
  const [profileTab, setProfileTab] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isGAMActive] = useState(true);

  // const { setSubTab } = props;
  const currentLocation = location.pathname.split("/");
  const navItem = currentLocation[currentLocation.length - 1];

  function onTabClick(route) {
    toggleDropdown();
    setProfileTab(route);
    if (route === "monetization") {
      setSubTab("/account/ads/earnings");
    }
  }

  function onSubTabClick(route) {
    toggleDropdown();
    setProfileTab(route);
    setSubTab(route);
  }

  function toggleDropdown() {
    const sideNav = document.getElementById("mobileNav");
    if(!sideNav) return;

    if (sideNav.style.display === "flex") {
      sideNav.style.display = "none";
      setIsDropdownOpen(false);
    } 
    else {
      sideNav.style.display = "flex";
      setIsDropdownOpen(true);
    }
  }

  useEffect(() => {
    setProfileTab(navItem);

    //eslint-disable-next-line
  }, []);

  const renderSubTabs = (pages) => {
    return pages.map((page) => {
      return (
        <NavLink
          to={page.path}
          activeClassName={classnames(styles.selected, styles.subtab)}
          onClick={() => onSubTabClick(page.name)}
          key={page.name}
        >
          <span className={styles.subpageTitle}>{page.name}</span>
        </NavLink>
      );
    });
  };

  function mobileDropdown() {
    return (
      <ul className={styles.sideNavWrapper} id="mobileNav">
        <NavLink
          to="/account/profile"
          activeClassName={styles.selected}
          onClick={() => onTabClick("profile")}
        >
          <span>Profile</span>
        </NavLink>
        <NavLink
          to="/account/subscription"
          activeClassName={styles.selected}
          onClick={() => onTabClick("subscription")}
        >
          <span>Device Management</span>
        </NavLink>
        <NavLink
          to="/account/ads/earnings"
          activeClassName={styles.selected}
          isActive={(match, location) => {
            if (
              location.pathname === "/account/ads/games" ||
              location.pathname === "/account/ads/earnings" ||
              location.pathname === "/account/ads/settings"
            ) {
              return true;
            }
          }}
          onClick={() => onTabClick("monetization")}
        >
          <span>Adbox</span>
        </NavLink>
        {isGAMActive && <>{renderSubTabs(AD_MANAGER_SUBROUTES)}</>}
        <NavLink
          to="/account/support"
          activeClassName={styles.selected}
          onClick={() => onTabClick("support")}
        >
          <span>Support</span>
        </NavLink>
      </ul>
    );
  }
  return (
    <div className={styles.wrapper}>
      <button className={styles.mobileNavBtn} onClick={toggleDropdown}>
        <span>{profileTab}</span>
        <FontAwesomeIcon
          className={styles.dropdownIcon}
          icon={isDropdownOpen ? faCaretDown : faCaretUp}
        />
      </button>
      <div className={styles.mobileWrapper}>{mobileDropdown()}</div>
      <ul className={styles.sideNavWrapper} id="desktopNav">
        <NavLink
          to="/account/profile"
          activeClassName={styles.selected}
          onClick={() => onTabClick("profile")}
        >
          <span>Profile</span>
        </NavLink>
        <NavLink
          to="/account/subscription"
          activeClassName={styles.selected}
          onClick={() => onTabClick("subscription")}
        >
          <span>Device Management</span>
        </NavLink>
        <NavLink
          to="/account/ads/earnings"
          activeClassName={classnames(styles.selected, styles.disabled)}
          isActive={(match, location) => {
            if (
              location.pathname === "/account/ads/games" ||
              location.pathname === "/account/ads/earnings" ||
              location.pathname === "/account/ads/settings"
            ) {
              return true;
            }
          }}
          onClick={() => onTabClick("monetization")}
        >
          <span>Adbox</span>
        </NavLink>
        <NavLink
          to="/account/support"
          activeClassName={styles.selected}
          onClick={() => onTabClick("support")}
        >
          <span>Support</span>
        </NavLink>
      </ul>
    </div>
  );
}
